import { SlideIn, StaggerContainer, StaggerItem, ViewportReveal, HoverScale, Pulse } from "@/components/motion";

const pillars = [
    {
        title: 'Pre-Screened Expertise',
        description: 'Skip the hiring process. Every expert is rigorously evaluated for technical skill, communication, and reliability.',
    },
    {
        title: 'Always Current',
        description: 'Monthly training ensures every consultant brings the latest AI breakthroughs into your roadmap.',
    },
    {
        title: 'True Integration',
        description: 'Our consultants become extensions of your team with aligned incentives and transparent communication.',
    },
]

export function EmbeddedConsultingSection() {
    return (
        <section
            id="clients"
            className="rounded-t-[80px] bg-[#1E293B] px-4 py-24 text-white sm:px-6 lg:px-8"
        >
            <ViewportReveal animation="fade" className="mx-auto max-w-5xl text-center">
                <SlideIn direction="up" delay={0.05}>
                    <p className="text-sm font-bold uppercase tracking-[1px] text-[#4163EC]">For businesses</p>
                </SlideIn>
                <SlideIn direction="up" delay={0.1}>
                    <h2 className="mt-3 text-4xl font-extrabold sm:text-5xl">Embedded Consulting. Not Gig Work.</h2>
                </SlideIn>
                <SlideIn direction="up" delay={0.2}>
                    <p className="mx-auto mt-6 w-2/3 text-[20px] font-normal text-[#CBD5E1]">
                        Work with AI experts who integrate into your team seamlessly. Every consultant is continuously trained, so
                        you always get cutting-edge expertise backed by a supportive community.
                    </p>
                </SlideIn>
            </ViewportReveal>

            <StaggerContainer staggerDelay={0.1} delayChildren={0.3} viewport className="mx-auto mt-16 grid max-w-6xl gap-8 lg:grid-cols-3">
                {pillars.map((pillar, index) => (
                    <StaggerItem key={pillar.title}>
                        <HoverScale scale={1.03}>
                            <article className="rounded-3xl border border-white/10 bg-white/5 p-8 backdrop-blur transition hover:border-white/30 h-full">
                                <Pulse scale={1.1} duration={2} delay={index * 0.3}>
                                    <div className="flex h-12 w-12 items-center justify-center rounded-2xl border border-[#3e5fe3] bg-[#334ebe] text-2xl font-bold text-white">
                                        ✓
                                    </div>
                                </Pulse>
                                <h3 className="mt-6 text-xl font-bold">{pillar.title}</h3>
                                <p className="mt-3 text-[#94A3B8] font-normal">{pillar.description}</p>
                            </article>
                        </HoverScale>
                    </StaggerItem>
                ))}
            </StaggerContainer>
        </section>
    )
}

